import React from "react";

function Footer() {
  return (
    <footer
      className="bg-[#F1EBE2] flex flex-col justify-end"
      role="contentinfo"
    >
      <div className="max-w-[1512px] mx-auto">
        <div className="flex justify-center items-center flex-col self-center py-10 lg:py-44 gap-5">
          <img
            src="/footer/league-life-logo.png"
            alt="League Life logo"
            className="w-[94px] h-auto lg:w-[119px]"
            loading="lazy"
            width="94"
            height="auto"
          />
          <a
            href="https://apps.apple.com/us/app/league-life/id1612547898"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download League Life on the App Store"
            className="mx-auto"
          >
            <img
              src="/footer/applestore-logo.png"
              alt="Download on the App Store"
              className="w-[188px] mx-auto lg:w-[239px]"
              loading="lazy"
              width="239"
              height="auto"
            />
          </a>
        </div>
        <div className="flex md:justify-between px-8 flex-col-reverse lg:flex-row justify-center text-center gap-10">
          <span className="font-bold text-2xl whitespace-nowrap">
            ©2025 LEAGUE LIFE™
          </span>
          <nav
            className="flex gap-4 flex-col lg:flex-row"
            aria-label="Footer navigation"
          >
            <a
              href="mailto:info@leaguelife.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-normal text-2xl underline underline-offset-8 hover:opacity-80 transition-opacity whitespace-nowrap"
            >
              Contact Us
            </a>
            <a
              href="/privacy-policy"
              className="font-normal text-2xl underline underline-offset-8 hover:opacity-80 transition-opacity whitespace-nowrap"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="font-normal text-2xl underline underline-offset-8 hover:opacity-80 transition-opacity whitespace-nowrap"
            >
              Terms of Use
            </a>
          </nav>
        </div>
        <img
          src="/footer/league-life.png"
          alt="League Life"
          className="w-full self-end mt-6 md:mt-0"
          loading="lazy"
          width="auto"
          height="auto"
        />
      </div>
    </footer>
  );
}

export { Footer };
